export const MAIN_OFFERS_TEST_IDS = {
  // ─── Offers Slider Section ───
  sectionContainer: 'main-offers-section-container',
  sectionTitle: 'main-offers-section-title',

  // ─── Tax Toggle ───
  taxToggleCheckbox: 'main-offers-tax-toggle-checkbox',
  taxToggleLabel: 'main-offers-tax-toggle-label',

  // ─── Filter Buttons ───
  filterButton: (label: string) => `main-offers-filter-btn-${label.toLowerCase()}`,

  // ─── Carousel ───
  carouselContainer: 'main-offers-carousel-container',

  // ─── Destination Card (dynamic per route) ───
  destinationCard: (id: string | number) => `main-offers-destination-card-${id}`,
  destinationCardImage: (id: string | number) => `main-offers-destination-card-image-${id}`,
  destinationCardRoute: (id: string | number) => `main-offers-destination-card-route-${id}`,
  destinationCardPrice: (id: string | number) => `main-offers-destination-card-price-${id}`,
  destinationCardOriginalPrice: (id: string | number) => `main-offers-destination-card-original-price-${id}`,
  destinationCardDiscount: (id: string | number) => `main-offers-destination-card-discount-${id}`,
} as const;
